import API from './api'

export const uploadFile = async (file: File): Promise<{ fileUrl: string }> => {
  const formData = new FormData()
  formData.append('file', file)
  return await API.post('/s3/upload/file', formData, {
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data', // 유지
    },
  })
}

export const uploadVideo = async (data: {
  file: File
  type: string
}): Promise<{ fileUrl: string }> => {
  const { file, type } = data
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)
  return await API.post('/s3/upload/file', formData, {
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data', // 유지
    },
  })
}

export const uploadVoice = async (file: File): Promise<{ fileUrl: string }> => {
  const formData = new FormData()
  formData.append('file', file)
  return await API.post('/s3/upload/voice', formData, {
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data', // 유지
    },
  })
}

export const deleteFile = async (url: string): Promise<{ fileUrl: string }> => {
  return await API.delete('s3/file', {
    params: { url },
  })
}
